// extracted by mini-css-extract-plugin
export var buttons = "_96-0";
export var buttonsActive = "_96-h";
export var cancelConfirm = "_96-1";
export var closeButton = "_96-2";
export var column = "_96-3";
export var container = "_96-4";
export var detailHeader = "_96-6";
export var detailTitle = "_96-7";
export var detailsContent = "_96-5";
export var header = "_96-8";
export var headerWithClose = "_96-9";
export var icon = "_96-a";
export var infoIcon = "_96-c";
export var informationContainer = "_96-b";
export var sideDrawer = "_96-d";
export var sideDrawerOpen = "_96-e";
export var stickyFooter = "_96-f";
export var typeOption = "_96-g";